export default __webpack_public_path__ + "static/media/es.a961ccd0.svg";